<script setup>
name: 'blogAuthorPage'
const route = useRoute()
const { getBlogSettings, getCategoryBySlug, getPosts } = useBlogData()
const { setPageHead } = useGlobalFeaturesData();

definePageMeta({
  layout: "blog",
});

let catSlug = route.params.slug

// Temporary geetting the first page created
const { data: settings, error: settingsError } = await getBlogSettings();

const { data: category, error: catError } = await getCategoryBySlug(catSlug);
if (catError.value) {
  throw createError({ statusCode: 404, statusMessage: catError.value })
}

// Default sort of posts
let paramsString = `?sort=publishedAt:DESC&pagination[page]=1&pagination[pageSize]=6&pagination[withCount]=true&filters[categories][slug][$eqi]=${catSlug}`
// Adjusts posts to get the first one on top and pass others to reel
const { data: postsReel, error: postsError } = await getPosts(paramsString)

// On this page we get the first posts so it is on the bigger section with the featured posts on the side
let postsArr = postsReel.value.data

// // Jump to top option
const displayJumpToTop = true;

</script>

<template>
  <BlogCategories :activeSlug="catSlug"/>
  <section class="author-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="breadcrumb">
            <NuxtLink class="breadcrumb-element" :href="`/blog`">Blog</NuxtLink>
            <span class="breadcrumb-element">></span>
            <span class="breadcrumb-element" v-html="category.category"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h1 class="author-name" v-html="category.category"></h1>
        </div>
      </div>
    </div>
  </section>
  <section class="blog-reel">
    <BlogPostsReel :posts="postsArr" :meta="postsReel.meta" :nextItem="7" :filters="`filters[categories][slug][$eqi]=${catSlug}`" />
  </section>
  <LayoutDynamicComponents v-if="sections" :sections="sections" />
  <LayoutBackToTop v-if="displayJumpToTop" />
</template>

<style lang="scss">
.breadcrumb {
  font-size: $font-size-smaller;

  a {
    font-weight: bold;
  }

  .breadcrumb-element {
    color: $color-primary;
    display: inline-block;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.blog-reel {
  padding-bottom: 40px;
}

@include media-breakpoint-up(lg) {
  .blog-reel {
    padding-top: 40px;
  }
}
</style>